/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
export const LOGIN_SUCCESS_ACTION = "LOGIN_SUCCESS_ACTION";
export const FETCH_STORE_SUCCESS = "FETCH_STORE_SUCCESS_ACTION";
export const LOGOUT_SUCCESS_ACTION = "LOGOUT_SUCCESS_ACTION";
export const SESSION_ERROR_ACTION = "SESSION_ERROR_ACTION";
export const SHOP_AS_USER_ACTION = "SHOP_AS_USER_ACTION";
export const RESET_SHOP_AS_USER_ACTION = "RESET_SHOP_AS_USER_ACTION";
export const RESET_ERROR_ACTION = "RESET_ERROR_ACTION";
export const EXPIRED_CSR_ACTION = "EXPIRED_CSR_ACTION";
